export const translations = ['de', 'en', 'es']
